module.exports = __webpack_public_path__ + "static/media/  (141).112bfb7f.jpg";